/**
 * Find Your Path: goal chips that each reveal a short list of recommendations.
 * Buttons use aria-pressed; one goal is open at a time. Left/Right arrows move between chips.
 */
if (!customElements.get('itc-path')) {
  customElements.define(
    'itc-path',
    class ItcPath extends HTMLElement {
      connectedCallback() {
        this.chips = Array.from(this.querySelectorAll('[data-path-chip]'));
        this.chips.forEach((chip, index) => {
          chip.addEventListener('click', () => this.toggle(chip));
          chip.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      toggle(chip) {
        const willOpen = chip.getAttribute('aria-pressed') !== 'true';
        this.chips.forEach((other) => {
          other.setAttribute('aria-pressed', 'false');
          const panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = true;
        });
        if (!willOpen) return;
        chip.setAttribute('aria-pressed', 'true');
        const panel = document.getElementById(chip.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
      }

      onKeydown(event, index) {
        let next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % this.chips.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.chips.length) % this.chips.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.chips.length - 1;
        if (next === null) return;
        event.preventDefault();
        this.chips[next].focus();
      }
    }
  );
}
